<template id="colorTemplate">
  <div class="component-container">
    <app-navigation></app-navigation>
    <form
      :class="formState.invalidShake ? 'invalid' : ''"
      :disabled="formState.loading"
      class="color-form"
    >
      <fieldset>
        <legend>Add new Color</legend>
        <div
          v-if="errors.length && formState.attempted && !formState.loading"
          class="col-12 col-sm-12"
        >
          <b class="w-100">Please correct the following error(s):</b>
          <ul>
            <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
          </ul>
        </div>
        <div class="row">
          <div class="form-group col-12">
            <label class="col-12">Verification SMS EX: welcome your verification code is</label>
            <input
              class="form-control"
              type="text"
              maxlength="200"
              v-model="sms_msg"
              placeholder="Verification SMS"
            />
            <button
              :disabled="formState.loading"
              type="button"
              v-on:click="updateAppMessages('sms_msg')"
              class="btn btn-primary"
            >
              Update Verification SMS
            </button>
          </div>
          <div class="form-group col-12">
            <label class="col-12">Welcome Email Title</label>
            <input
              class="form-control"
              type="text"
              maxlength="200"
              v-model="welcome_title"
              placeholder="Welcome Email Title"
            />
            <button
              :disabled="formState.loading"
              type="button"
              v-on:click="updateAppMessages('welcome_title')"
              class="btn btn-primary"
            >
              Update Welcome Email Title
            </button>
          </div>
          <div class="form-group col-12">
            <label class="col-12">Welcome Email Message</label>
            <input
              class="form-control"
              type="text"
              maxlength="200"
              v-model="welcome_message"
              placeholder="Welcome Email Message"
            />
            <button
              :disabled="formState.loading"
              type="button"
              v-on:click="updateAppMessages('welcome_message')"
              class="btn btn-primary"
            >
              Update Welcome Email Message
            </button>
          </div>
          <div class="col-sm-12">
            <strong>
              Please use an image that has an aspect ratio of
              <br />
              1 : {{ parseFloat(30 / 100).toFixed(2) }} (W : H) - Example:
              600x200
              <br />
              Ignoring this may cause distortion of the image on the website
            </strong>
            <br />
          </div>

          <div class="form-group col-6">
            <label class="col-12 col-sm-12">Welcome Email Image</label>
            <input
              class="form-control-file"
              type="file"
              id="image"
              @change="uploadFile('image')"
              :disabled="formState.loading"
            />
            
        <button
            :disabled="formState.loading"
            type="button"
            v-on:click="updateAppMessages('welcome_img')"
            class="btn btn-primary"
        >
            Update Welcome Email Image
        </button>
          </div>
          <div class="col-6">
              <img :src="image.value" alt="" width="100%">
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</template>


<!-- color Template -->




<style lang='scss' scoped>
@import url("https://fonts.googleapis.com/css?family=PT+Sans");
@import "../../node_modules/bootstrap/scss/bootstrap.scss";
.modified-dropdown {
  -webkit-appearance: menulist;
  background: none;
}
.component-container {
  min-height: 100%;
  display: flex;
}
.color-form {
  float: right;
  padding: 50px;
  width: 80%;
  text-align: left;
  label {
    padding-left: 0;
  }

  div {
    padding: 10px;
  }

  button {
    margin: 0 auto;
    padding: 6px;
    font-size: 16px;
  }
}
.invalid {
  animation: shake 0.82s infinite cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}
.form-control{width: 70%!important;display: inline-block!important;}
</style>

<script>
import axios from "axios";
/* eslint-disable no-unused-vars */
import VueAxios from "vue-axios";
import { constants } from "crypto";
/* eslint-enable no-unused-vars*/
import { herokuUrl } from "../apiConfig";
import { getCookie } from "../cookie.js";
import Navigation from "../components/Navigation.vue";
import logOut from "../scripts/utils";

export default {
  name: "AddColor",
  data() {
    return {
      errors: [],
      colors: [],
      sms_msg: "",
      welcome_title: "",
      welcome_message: "",
      image: {
        uploaded: null,
        newFileUpload: null,
        value: "https://i2.wp.com/sociallover.net/wp-content/uploads/2017/08/welcome-pictures.png",
      },
      formState: {
        attempted: false,
        invalidShake: false,
        loading: false,
      },
      compressedFile: null,
      compressedFileFlag: false,
    };
  },
  watch: {
    name: function () {
      this.checkForm();
    },
    nameEN: function () {
      this.checkForm();
    },
    "image.uploaded": function() {
      this.checkForm();
    }
  },
  mounted() {
    this.fetchMsgs();
    // this.checkForm();
  },
  methods: {
    compress(elem) {
      const width = 600;
      const height = 200;
      const fileName = elem.files[0].name;
      const reader = new FileReader();
      console.log(elem.files[0]);
      reader.readAsDataURL(elem.files[0]);
      return (reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        (img.onload = () => {
          const elem = document.createElement("canvas");
          elem.width = width;
          elem.height = height;
          const ctx = elem.getContext("2d");
          // img.width and img.height will contain the original dimensions
          ctx.drawImage(img, 0, 0, width, height);
          ctx.canvas.toBlob(
            (blob) => {
              const file = new File([blob], fileName, {
                type: "image/jpeg",
                lastModified: Date.now(),
              });
              this.compressedFileFlag = true;
              this.compressedFile = file;
            },
            "image/jpeg",
            1
          );
        }),
          (reader.onerror = (error) => {
            this.compressedFileFlag = "error";
            console.log(error);
          });
      });
    },
    // Whenever an input of type file changes, the selected file is uploaded to the backend
    uploadFile() {
      if (
        !(
          document.getElementById("image").files[0] &&
          document.getElementById("image").files[0].name
        )
      )
        return;
      this.formState.loading = true;
      this.image.uploaded = false;
      this.compress(document.getElementById("image"));
      this.image.newFileUpload = new FormData();
      // let file = document.getElementById("image").files[0];
      let fn = () => {
        if (this.compressedFileFlag && this.compressedFileFlag != "error") {
          this.image.newFileUpload.set("images", this.compressedFile);
          axios
            .post(`${herokuUrl}/adminUpload`, this.image.newFileUpload, {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: getCookie("user"),
              },
            })
            .then((res) => {
              if (res.data.status) {
                this.image.uploaded = true;
                this.image.value = res.data.sources[0];
                this.formState.loading = false;
              } else {
                alert(
                  "Couldn't Upload file, File too large or    " + res.message
                );
                this.formState.loading = false;
              }
            })
            .catch((err) => {
              console.log(err);
              if (err.response.status == 401) {
                logOut();
              } else {
                alert(
                  "Couldn't Upload file, File too large or    " +
                    err.response.data.message
                );
                this.formState.loading = false;
              }
            });
        } else if (this.compressedFileFlag == "error") {
          alert("Compression Error");
          this.formState.loading = false;
        } else {
          setTimeout(fn, 200);
        }
      };
      fn();
    },
    checkForm: function () {
      this.errors = [];
      if (!this.name) {
        this.errors.push("Name is required");
      }
      if (!this.nameEN) {
        this.errors.push("Name (EN) is required");
      }
      if (!this.image.value) {
        this.errors.push("Image is required");
      }
    },
    fetchMsgs() {
      this.formState.loading = true;
      return Promise.all([
        axios.get(`${herokuUrl}/app_messages`, null, {
          headers: {
            Authorization: getCookie("user"),
          },
        }),
      ])
        .then((res) => {
          console.log(res[0].data["messages"]);
          this.sms_msg = res[0].data["messages"].filter(i => i.type == 'sms_msg')[0].message;
          this.welcome_message = res[0].data["messages"].filter(i => i.type == 'welcome_message')[0].message;
          this.image.value = res[0].data["messages"].filter(i => i.type == 'welcome_img')[0].message;
          this.welcome_title = res[0].data["messages"].filter(i => i.type == 'welcome_title')[0].message;
          this.formState.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateAppMessages(type) {
        let msg;
        if(type === "sms_msg"){
            msg = this.sms_msg;
        }else if(type === "welcome_message"){
            msg = this.welcome_message;
        }else if(type === "welcome_img"){
            msg = this.image.value;
        }else if(type === "welcome_title"){
            msg = this.welcome_title;
        }
      this.formState.attempted = true;
    //   if (!this.errors.length) {
        this.formState.loading = true;
        axios
          .post(
            `${herokuUrl}/update_app_messages`,
            {
              type,
              msg,
            },
            {
              headers: {
                Authorization: getCookie("user"),
              },
            }
          )
          .then(() => {
            this.formState.loading = false;
            this.formState.attempted = false;
            alert("App Messages were updated successfully");
            this.fetchMsgs();
          })
          .catch((err) => {
            if (err.response.status == 401) {
              logOut();
            } else {
              this.formState.loading = false;
              alert("There was an error, " + err.response.data.message);
            }
          });
    //   } else {
    //     this.shakeForm();
    //   }
    },
    shakeForm() {
      this.formState.invalidShake = true;
      setTimeout(
        function () {
          this.formState.invalidShake = false;
        }.bind(this),
        820
      );
    },
  },
  components: {
    appNavigation: Navigation,
  },
};
</script>
